import { ScreenPartConfig } from './screen-part.types';

export type ScreenPartConfigKey = 'package' | 'product' | 'booking';

/** 라우트 data용 키 (definition은 screen-part-definition feature에서 사용) */
export type ScreenPartRouteKey = ScreenPartConfigKey | 'definition';

export interface ScreenPartRouteData {
  screenPartKey: ScreenPartRouteKey;
  config: ScreenPartConfig;
  title: string;
}

export const SCREEN_PART_CONFIG: ScreenPartConfig = {
  title: 'brandFn.menu.screenPart',
  apiBasePath: 'api/screen-part',
  isDefinition: false,
  viewType: 'table',
  searchFields: [
    { name: 'id', type: 'text', label: 'REPO.TABLE.screenPart.id' },
    {
      name: 'partCategory',
      type: 'select',
      label: 'REPO.TABLE.screenPart.partCategory',
      options: [
        { value: 'PACKAGE', label: 'PACKAGE' },
        { value: 'HOTEL', label: 'HOTEL' },
        { value: 'PARTNERS', label: 'PARTNERS' },
        { value: 'AGENTS', label: 'AGENTS' },
        { value: 'LOGIN', label: 'LOGIN' },
        { value: 'RESTAURANT', label: 'RESTAURANT' },
        { value: 'COMMON', label: 'COMMON' },
        { value: 'BOOKING', label: 'BOOKING' },
        { value: 'PAYMENT', label: 'PAYMENT' },
        { value: 'ARTICLE', label: 'ARTICLE' },
      ],
    },
    { name: 'name', type: 'text', label: 'REPO.TABLE.screenPart.name' },
    {
      name: 'partType',
      type: 'select',
      label: 'REPO.TABLE.screenPart.partType',
      options: [
        // PACKAGE
        { value: 'PKG_HEADER', label: 'Header' },
        { value: 'PKG_GALLERY', label: 'Gallery' },
        { value: 'PKG_SCHEDULE', label: 'Schedule' },
        { value: 'PKG_SCHEDULE_TAB', label: 'Schedule Tab' },
        { value: 'PKG_SCHEDULE_TIMELINE', label: 'Schedule Timeline' },
        { value: 'PKG_FLIGHT_INFO', label: 'Flight Info' },
        { value: 'PKG_TAB_NAVIGATION', label: 'Tab Navigation' },
        { value: 'PKG_BOTTOM_BAR', label: 'Bottom Bar' },
        { value: 'PKG_PROMOTION', label: 'Promotion' },
        { value: 'PKG_RELATED_PACKAGES', label: 'Related Packages' },
        { value: 'PKG_CASE_SELECTOR', label: 'Case Selector' },
        { value: 'PKG_PRICING_BREAKDOWN', label: '가격 분해 (4단)' },
        { value: 'PKG_FACILITY_LIST', label: 'Facility List' },
        { value: 'PKG_PRICE_BY_PAX', label: '가격 안내 (인원 구분별)' },
        { value: 'PKG_ETC_CONTENT', label: 'Etc Content' },
        // COMMON
        { value: 'CMN_DESCRIPTION', label: 'Description' },
        { value: 'CMN_PRICE', label: 'Price' },
        { value: 'CMN_REVIEW', label: 'Review' },
        { value: 'CMN_FAQ', label: 'FAQ' },
        { value: 'CMN_ROUTE_MAP', label: 'Route Map' },
        { value: 'CMN_LOCATION_MAP', label: 'Location Map' },
        { value: 'CMN_NOTICE', label: 'Notice' },
        // 2026-09-11 안내 섹션 통합 + 커머스 모던 신규 2종
        { value: 'CMN_INFO', label: 'Info Section' },
        { value: 'CMN_SECTION_HEADER', label: 'Section Header' },
        { value: 'CMN_DIVIDER', label: 'Divider' },
        { value: 'CMN_CUSTOM_HTML', label: 'Custom HTML' },
        { value: 'CMN_HIGHLIGHT', label: 'Highlight' },
        { value: 'CMN_IMAGE', label: 'Image' },
        { value: 'CMN_VIDEO', label: 'Video' },
        { value: 'CMN_CALENDAR', label: 'Calendar' },
        // BOOKING
        { value: 'BKG_BOOKING_WIDGET', label: 'Booking Widget' },
        { value: 'BKG_PERSON_INPUT', label: 'Person Input' },
        { value: 'BKG_PAYMENT', label: 'Payment' },
        { value: 'BKG_MOBILE_BAR', label: 'Mobile Bar' },
        { value: 'BKG_BUYER_INFO', label: 'Buyer Info' },
        { value: 'BKG_TRAVELERS', label: 'Travelers (Buyer + Companions)' },
        { value: 'BKG_TRIP_SUMMARY', label: 'Trip Summary' },
        { value: 'BKG_REMARKS', label: 'Remarks' },
        { value: 'BKG_CANCELLATION_POLICY', label: 'Cancellation Policy' },
        { value: 'BKG_ROOM_SELECTION', label: 'Room Selection' },
        { value: 'BKG_ESTIMATE_OPTIONS', label: 'Estimate Options (customer-selectable)' },
        { value: 'BKG_FLIGHT_SELECTION', label: 'Flight Selection' },
        { value: 'BKG_MEMBER_FORM', label: 'Member Form' },
        { value: 'BKG_PRICE_TABLE', label: 'Price Table' },
        { value: 'BKG_HOTEL_DATE_PICKER', label: 'Hotel Date Picker' },
        { value: 'BKG_HOTEL_ROOM_SELECT', label: 'Hotel Room Select' },
        { value: 'BKG_HOTEL_GUEST_INFO', label: 'Hotel Guest Info' },
        { value: 'BKG_VEHICLE_ROUTE', label: 'Vehicle Route' },
        { value: 'BKG_VEHICLE_PICKUP', label: 'Vehicle Pickup' },
        { value: 'BKG_VEHICLE_OPTIONS', label: 'Vehicle Options' },
        { value: 'BKG_CAR_SUMMARY', label: 'Car Summary (rental car option)' },
        { value: 'BKG_CAR_REQUEST_WIDGET', label: 'Car Request Widget (rental car option)' },
        { value: 'BKG_COMPLETE_MESSAGE', label: 'Complete Message' },
        { value: 'BKG_BOOKING_SUMMARY', label: 'Booking Summary' },
        { value: 'BKG_NEXT_ACTION', label: 'Next Action' },
        { value: 'BKG_MANAGE_CARD', label: 'Manage Card' },
        { value: 'BKG_NEXT_STEPS', label: 'Next Steps' },
        { value: 'BKG_DEPOSIT_LIST', label: 'Deposit List' },
        { value: 'BKG_PACKAGE_ETC_CONTENT', label: 'Package Etc Content' },
        { value: 'BKG_SUPPORT_CONTACT', label: 'Support Contact' },
        { value: 'BKG_DETAIL_HEADER', label: 'Detail Header' },
        { value: 'BKG_ITINERARY', label: 'Itinerary' },
        { value: 'BKG_DETAIL_ACTIONS', label: 'Detail Actions' },
        // PAYMENT
        { value: 'PAY_ORDER_SUMMARY', label: 'Order Summary' },
        { value: 'PAY_METHOD', label: 'Payment Method' },
        { value: 'PAY_EASY_PAY', label: 'Easy Pay' },
        { value: 'PAY_COUPON', label: 'Coupon' },
        { value: 'PAY_PRICE_BREAKDOWN', label: 'Price Breakdown' },
        { value: 'PAY_AGREEMENT', label: 'Agreement' },
        { value: 'PAY_CTA_BUTTON', label: 'CTA Button' },
        { value: 'PAY_MOBILE_BAR', label: 'Pay Mobile Bar' },
        // CUSTOM (Carenity)
        { value: 'CRNTY_SCHEDULE_TAB', label: 'Carenity Schedule Tab' },
        { value: 'CRNTY_HEADER', label: 'Carenity Header' },
        { value: 'CRNTY_CALENDAR', label: 'Carenity Calendar' },
        // HOTEL
        { value: 'HOTEL_BREADCRUMB', label: 'Hotel Breadcrumb' },
        { value: 'HOTEL_TAB_NAVIGATION', label: 'Hotel Tab Navigation' },
        { value: 'HOTEL_HEADER', label: 'Hotel Header' },
        { value: 'HOTEL_DESC', label: 'Hotel Description' },
        { value: 'HOTEL_INTRO_SECTIONS', label: 'Hotel Intro Sections' },
        { value: 'HOTEL_ROOM_LIST', label: 'Hotel Room List' },
        { value: 'HOTEL_ROOM_RATE_LIST', label: 'Hotel Room Rate List' },
        { value: 'HOTEL_AMENITIES', label: 'Hotel Amenities' },
        { value: 'HOTEL_QUICK_INFO', label: 'Hotel Quick Info' },
        { value: 'HOTEL_CHECK_IN_OUT', label: 'Hotel Check In/Out' },
        { value: 'HOTEL_BOOKING', label: 'Hotel Booking' },
        { value: 'HOTEL_CONTACT', label: 'Hotel Contact' },
        { value: 'HOTEL_LOCATION', label: 'Hotel Location' },
        { value: 'HOTEL_GREETING', label: 'Hotel Greeting' },
        { value: 'HOTEL_BOOKING_CONDITION', label: 'Hotel Booking Condition' },
        { value: 'HOTEL_HIGHLIGHTS', label: 'Hotel Highlights' },
        { value: 'HOTEL_POLICY', label: 'Hotel Policy' },
        // PARTNERS
        { value: 'PARTNERS_HEADER', label: 'Partners Header' },
        { value: 'PARTNERS_PROFILE', label: 'Partners Profile' },
        { value: 'PARTNERS_INTRO', label: 'Partners Intro' },
        { value: 'PARTNERS_OVERVIEW', label: 'Partners Overview' },
        { value: 'PARTNERS_PRODUCTS', label: 'Partners Products' },
        { value: 'PARTNERS_DESC', label: 'Partners Description' },
        { value: 'PARTNERS_REMARK', label: 'Partners Remark' },
        { value: 'PARTNERS_CONTACT', label: 'Partners Contact' },
        // AGENTS
        { value: 'AGENT_HEADER', label: 'Agent Header' },
        { value: 'AGENT_OVERVIEW', label: 'Agent Overview' },
        { value: 'AGENT_CONTACT', label: 'Agent Contact' },
        { value: 'AGENT_EXPERTISE', label: 'Agent Expertise' },
        { value: 'AGENT_REGIONS', label: 'Agent Regions' },
        { value: 'AGENT_SERVICES', label: 'Agent Services' },
        { value: 'AGENT_CAREER', label: 'Agent Career' },
        { value: 'AGENT_RELATED', label: 'Agent Related' },
        // LOGIN
        { value: 'LOGIN_HEADER', label: 'Login Header' },
        { value: 'LOGIN_ROLE_TABS', label: 'Login Role Tabs' },
        { value: 'LOGIN_ROLE_DESC', label: 'Login Role Description' },
        { value: 'LOGIN_SOCIAL_BUTTONS', label: 'Login Social Buttons' },
        { value: 'LOGIN_EMAIL_FORM', label: 'Login Email Form' },
        { value: 'LOGIN_SUBMIT_BUTTON', label: 'Login Submit Button' },
        { value: 'LOGIN_SIGNUP_LINK', label: 'Login Signup Link' },
        // RESTAURANT
        { value: 'RESTAURANT_BREADCRUMB', label: 'Restaurant Breadcrumb' },
        { value: 'RESTAURANT_HEADER', label: 'Restaurant Header' },
        { value: 'RESTAURANT_DESC', label: 'Restaurant Description' },
        { value: 'RESTAURANT_MENU_LIST', label: 'Restaurant Menu List' },
        { value: 'RESTAURANT_AMENITIES', label: 'Restaurant Amenities' },
        { value: 'RESTAURANT_HOURS', label: 'Restaurant Hours' },
        { value: 'RESTAURANT_BOOKING', label: 'Restaurant Booking' },
        { value: 'RESTAURANT_CONTACT', label: 'Restaurant Contact' },
        { value: 'RESTAURANT_GREETING', label: 'Restaurant Greeting' },
      ],
    },
  ],
  columns: [
    {
      key: 'id',
      name: 'REPO.TABLE.screenPart.id',
      type: 'number',
      width: '80px',
      class: 'text-center',
      sortable: true,
    },
    {
      key: 'partCategory',
      name: 'REPO.TABLE.screenPart.partCategory',
      type: 'text',
      width: '120px',
      sortable: true,
    },
    {
      key: 'name',
      name: 'REPO.TABLE.screenPart.name',
      type: 'text',
      width: '200px',
      sortable: true,
      filterable: true,
    },
    {
      key: 'partType',
      name: 'REPO.TABLE.screenPart.partType',
      type: 'text',
      width: '200px',
      sortable: true,
    },
    {
      key: 'description',
      name: 'REPO.TABLE.partDefinition.description',
      type: 'text',
      sortable: false,
      filterable: false,
    },
    {
      key: 'updatedAt',
      name: 'REPO.TABLE.screenPart.updatedAt',
      type: 'date',
      width: '150px',
      class: 'text-center',
      dateFormat: 'yyyy-MM-dd HH:mm',
      sortable: true,
    },
  ],
  defaultPageSize: 5,
  defaultSort: 'id,desc',
  routePath: 'homepage-master/part',
};

export const SCREEN_PART_CONFIGS: Record<
  ScreenPartConfigKey,
  ScreenPartConfig
> = {
  package: {
    title: 'brandFn.menu.screenPart',
    domain: 'package',
    apiBasePath: 'api/screen-part/package',
    viewType: 'table',
    searchFields: [
      { name: 'id', type: 'text', label: 'REPO.TABLE.screenPart.id' },
      { name: 'name', type: 'text', label: 'REPO.TABLE.screenPart.name' },
      {
        name: 'partType',
        type: 'select',
        label: 'REPO.TABLE.screenPart.partType',
        options: [
          { value: 'PKG_HEADER', label: 'Header' },
          { value: 'PKG_GALLERY', label: 'Gallery' },
          { value: 'PKG_SCHEDULE', label: 'Schedule' },
          { value: 'PKG_SCHEDULE_TAB', label: 'Schedule Tab' },
          { value: 'PKG_SCHEDULE_TIMELINE', label: 'Schedule Timeline' },
          { value: 'PKG_FLIGHT_INFO', label: 'Flight Info' },
          { value: 'PKG_TAB_NAVIGATION', label: 'Tab Navigation' },
          { value: 'PKG_BOTTOM_BAR', label: 'Bottom Bar' },
          { value: 'PKG_PROMOTION', label: 'Promotion' },
          { value: 'PKG_RELATED_PACKAGES', label: 'Related Packages' },
          { value: 'PKG_CASE_SELECTOR', label: 'Case Selector' },
          { value: 'PKG_PRICING_BREAKDOWN', label: '가격 분해 (4단)' },
          { value: 'CMN_DESCRIPTION', label: 'Description' },
          { value: 'CMN_PRICE', label: 'Price' },
          { value: 'CMN_NOTICE', label: 'Notice' },
          { value: 'CMN_INFO', label: 'Info Section' },
          { value: 'CMN_SECTION_HEADER', label: 'Section Header' },
          { value: 'CMN_DIVIDER', label: 'Divider' },
          { value: 'CMN_CUSTOM_HTML', label: 'Custom HTML' },
          { value: 'CMN_HIGHLIGHT', label: 'Highlight' },
          { value: 'CMN_IMAGE', label: 'Image' },
          { value: 'PKG_FACILITY_LIST', label: 'Facility List' },
          { value: 'PKG_PRICE_BY_PAX', label: '가격 안내 (인원 구분별)' },
          { value: 'PKG_ETC_CONTENT', label: 'Etc Content' },
          { value: 'CMN_REVIEW', label: 'Review' },
          { value: 'CMN_FAQ', label: 'FAQ' },
          { value: 'CMN_ROUTE_MAP', label: 'Route Map' },
          { value: 'CMN_LOCATION_MAP', label: 'Location Map' },
          { value: 'BKG_BOOKING_WIDGET', label: 'Booking Widget' },
          { value: 'CMN_CALENDAR', label: 'Calendar' },
          { value: 'BKG_PERSON_INPUT', label: 'Person Input' },
          { value: 'BKG_PAYMENT', label: 'Payment' },
          { value: 'CRNTY_SCHEDULE_TAB', label: 'Carenity Schedule Tab' },
          { value: 'CRNTY_HEADER', label: 'Carenity Header' },
          { value: 'CRNTY_CALENDAR', label: 'Carenity Calendar' },
        ],
      },
    ],
    columns: [
      {
        key: 'id',
        name: 'REPO.TABLE.screenPart.id',
        type: 'number',
        width: '80px',
        class: 'text-center',
        sortable: true,
      },
      {
        key: 'name',
        name: 'REPO.TABLE.screenPart.name',
        type: 'text',
        sortable: true,
        filterable: true,
      },
      {
        key: 'partType',
        name: 'REPO.TABLE.screenPart.partType',
        type: 'text',
        width: '150px',
        sortable: true,
      },
      {
        key: 'updatedAt',
        name: 'REPO.TABLE.screenPart.updatedAt',
        type: 'date',
        width: '150px',
        class: 'text-center',
        dateFormat: 'yyyy-MM-dd HH:mm',
        sortable: true,
      },
    ],
    defaultPageSize: 5,
    defaultSort: 'id,desc',
    routePath: 'homepage-master/package/part',
  },
  product: {
    title: 'brandFn.menu.screenPart',
    domain: 'product',
    apiBasePath: 'api/screen-part/product',
    viewType: 'table',
    searchFields: [
      { name: 'id', type: 'text', label: 'REPO.TABLE.screenPart.id' },
      { name: 'name', type: 'text', label: 'REPO.TABLE.screenPart.name' },
      {
        name: 'partType',
        type: 'select',
        label: 'REPO.TABLE.screenPart.partType',
        options: [
          { value: 'PKG_HEADER', label: 'Header' },
          { value: 'PKG_GALLERY', label: 'Gallery' },
          { value: 'CMN_DESCRIPTION', label: 'Description' },
          { value: 'CMN_PRICE', label: 'Price' },
          { value: 'CMN_REVIEW', label: 'Review' },
          { value: 'CMN_FAQ', label: 'FAQ' },
          { value: 'CMN_ROUTE_MAP', label: 'Route Map' },
          { value: 'CMN_LOCATION_MAP', label: 'Location Map' },
          { value: 'CMN_VIDEO', label: 'Video' },
          { value: 'CMN_CUSTOM_HTML', label: 'Custom HTML' },
        ],
      },
    ],
    columns: [
      {
        key: 'id',
        name: 'REPO.TABLE.screenPart.id',
        type: 'number',
        width: '80px',
        class: 'text-center',
        sortable: true,
      },
      {
        key: 'name',
        name: 'REPO.TABLE.screenPart.name',
        type: 'text',
        sortable: true,
        filterable: true,
      },
      {
        key: 'partType',
        name: 'REPO.TABLE.screenPart.partType',
        type: 'text',
        width: '150px',
        sortable: true,
      },
      {
        key: 'updatedAt',
        name: 'REPO.TABLE.screenPart.updatedAt',
        type: 'date',
        width: '150px',
        class: 'text-center',
        dateFormat: 'yyyy-MM-dd HH:mm',
        sortable: true,
      },
    ],
    defaultPageSize: 5,
    defaultSort: 'id,desc',
    routePath: 'homepage-master/product/part',
  },
  booking: {
    title: 'brandFn.menu.screenPart',
    domain: 'booking',
    apiBasePath: 'api/screen-part/booking',
    viewType: 'table',
    searchFields: [
      { name: 'id', type: 'text', label: 'REPO.TABLE.screenPart.id' },
      { name: 'name', type: 'text', label: 'REPO.TABLE.screenPart.name' },
      {
        name: 'partType',
        type: 'select',
        label: 'REPO.TABLE.screenPart.partType',
        options: [
          { value: 'BKG_BOOKING_WIDGET', label: 'Booking Widget' },
          { value: 'CMN_CALENDAR', label: 'Calendar' },
          { value: 'BKG_PERSON_INPUT', label: 'Person Input' },
          { value: 'BKG_PAYMENT', label: 'Payment' },
          { value: 'BKG_MOBILE_BAR', label: 'Mobile Bar' },
          { value: 'BKG_BUYER_INFO', label: 'Buyer Info' },
          { value: 'BKG_TRAVELERS', label: 'Travelers (Buyer + Companions)' },
          { value: 'BKG_TRIP_SUMMARY', label: 'Trip Summary' },
          { value: 'BKG_REMARKS', label: 'Remarks' },
          { value: 'BKG_CANCELLATION_POLICY', label: 'Cancellation Policy' },
          { value: 'BKG_ROOM_SELECTION', label: 'Room Selection' },
          { value: 'BKG_ESTIMATE_OPTIONS', label: 'Estimate Options (customer-selectable)' },
          { value: 'BKG_FLIGHT_SELECTION', label: 'Flight Selection' },
          { value: 'BKG_MEMBER_FORM', label: 'Member Form' },
          { value: 'BKG_PRICE_TABLE', label: 'Price Table' },
          { value: 'BKG_HOTEL_DATE_PICKER', label: 'Hotel Date Picker' },
          { value: 'BKG_HOTEL_ROOM_SELECT', label: 'Hotel Room Select' },
          { value: 'BKG_HOTEL_GUEST_INFO', label: 'Hotel Guest Info' },
          { value: 'BKG_VEHICLE_ROUTE', label: 'Vehicle Route' },
          { value: 'BKG_VEHICLE_PICKUP', label: 'Vehicle Pickup' },
          { value: 'BKG_VEHICLE_OPTIONS', label: 'Vehicle Options' },
          { value: 'BKG_CAR_SUMMARY', label: 'Car Summary (rental car option)' },
          { value: 'BKG_CAR_REQUEST_WIDGET', label: 'Car Request Widget (rental car option)' },
          { value: 'BKG_COMPLETE_MESSAGE', label: 'Complete Message' },
          { value: 'BKG_BOOKING_SUMMARY', label: 'Booking Summary' },
          { value: 'BKG_NEXT_ACTION', label: 'Next Action' },
          { value: 'BKG_MANAGE_CARD', label: 'Manage Card' },
          { value: 'BKG_NEXT_STEPS', label: 'Next Steps' },
          { value: 'BKG_DEPOSIT_LIST', label: 'Deposit List' },
          { value: 'BKG_PACKAGE_ETC_CONTENT', label: 'Package Etc Content' },
          { value: 'BKG_SUPPORT_CONTACT', label: 'Support Contact' },
          { value: 'BKG_DETAIL_HEADER', label: 'Detail Header' },
          { value: 'BKG_ITINERARY', label: 'Itinerary' },
          { value: 'BKG_DETAIL_ACTIONS', label: 'Detail Actions' },
          { value: 'PAY_ORDER_SUMMARY', label: 'Order Summary' },
          { value: 'PAY_METHOD', label: 'Payment Method' },
          { value: 'PAY_EASY_PAY', label: 'Easy Pay' },
          { value: 'PAY_COUPON', label: 'Coupon' },
          { value: 'PAY_PRICE_BREAKDOWN', label: 'Price Breakdown' },
          { value: 'PAY_AGREEMENT', label: 'Agreement' },
          { value: 'PAY_CTA_BUTTON', label: 'CTA Button' },
          { value: 'PAY_MOBILE_BAR', label: 'Pay Mobile Bar' },
          { value: 'CMN_CUSTOM_HTML', label: 'Custom HTML' },
        ],
      },
    ],
    columns: [
      {
        key: 'id',
        name: 'REPO.TABLE.screenPart.id',
        type: 'number',
        width: '80px',
        class: 'text-center',
        sortable: true,
      },
      {
        key: 'name',
        name: 'REPO.TABLE.screenPart.name',
        type: 'text',
        sortable: true,
        filterable: true,
      },
      {
        key: 'partType',
        name: 'REPO.TABLE.screenPart.partType',
        type: 'text',
        width: '150px',
        sortable: true,
      },
      {
        key: 'updatedAt',
        name: 'REPO.TABLE.screenPart.updatedAt',
        type: 'date',
        width: '150px',
        class: 'text-center',
        dateFormat: 'yyyy-MM-dd HH:mm',
        sortable: true,
      },
    ],
    defaultPageSize: 5,
    defaultSort: 'id,desc',
    routePath: 'homepage-master/booking/part',
  },
};
